export default "__VITE_ASSET__qw$0xzJc__"